import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { distribuidorModulo } from '../../diccionarios/distribuidorModulo';
import { CatalogoService } from '../../services/catalogo.service';
import { DistribuidorService } from '../../services/distribuidor.service';
import { DistribuidorModel, DistribuidorModelInterface } from '../../models/distribuidorModel';
import { DistribuidorMantenedorModel, DistriMantenedorInterface } from '../../models/distribuidorMantenedorModel';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

@Component({
  selector: 'app-upload-csv-dis',
  templateUrl: './upload-csv-dis.component.html',
  styleUrls: ['./upload-csv-dis.component.css']
})
export class UploadCsvDisComponent implements OnInit {

  titulo: string = 'Clientes de Censo';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: DistribuidorModel[] = [];

  textoBuscarCli = '';
  gridApiCli: any;
  gridColumnApiCli: any;
  columnDefsCli: any[];
  frameworkComponentsCli: any;
  rowSelectionCli: any;
  rowDataCli: any[] = [];

  errorData: boolean = true;

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;
  listaVaciaCli: boolean = true;
  distribuidorModulo: any = {};
  cmbDistribuidor: DistribuidorMantenedorModel[] = [];

  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  modelGridDistribuidor: DistribuidorModelInterface;
  csv: string;

  dataDistribuidor: DistribuidorModel = {
    codigoFabril: '',
    codigoDistribuidor: '',
    tipoDocumento: '',//CatalogoTipoDocumento ;
    numeroIdentidad: '',
    razonSocial: '',
    nombreComercial: '',
    nombreCliente: '',
    // ciudad: 0,
    canton: 0,
    parroquia: 0,
    direccion: '',
    referenciaDireccion: '',
    regional: '', //CatalogoRegional ;
    telefonoFijo1: '',
    telefonoFijo2: '',
    telefonoCelular1: '',
    telefonoCelular2: '',
    correoElectronico1: '',
    correoElectronico2: '',
    longitud: '', //BigDecimal ;
    latitud: '', //BigDecimal ;
    codigoVendedorAsignado: '',
    imagenes: '',
    tier: 0,
    estadoEnDistribuidor: '',
    provincia: '',
    correct: false,
    devolverModeloGridDistribuidor() {
      return null
    }
  };
  modelDistribuidorMantenedor: DistriMantenedorInterface;
  objSelected: any;

  // img = "https://img.konami.com/kde_cms/eu_publish/uploads/lost_art_cards_es-600x322.png"
  constructor(public fb: FormBuilder,
    private _util: UtilsService,
    private _distribuidor: DistribuidorService,
    private catalogo: CatalogoService,
  ) { }

  ngOnInit() {
    this.formulario = this.fb.group({
      idDistribuidor: ['', [Validators.required]],
      multipart: ['', [Validators.required]],
    });
    const innDistribuidor = new DistribuidorModel();
    const innDistribuidorMantenedor = new DistribuidorMantenedorModel();
    this.modelGridDistribuidor = innDistribuidor.devolverModeloGridDistribuidor();
    this.modelDistribuidorMantenedor = innDistribuidorMantenedor.devolverModeloGridMantenedor();
    this.distribuidorModulo = distribuidorModulo;
    this.DAT_BTNS = this.distribuidorModulo.button.buttonsNombre;
    this.DAT_MSG = this.distribuidorModulo.mensajes;
    this.DAT_BTNCSS = this.distribuidorModulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();
    this.cargarGridCli();
    this.getDistribuidor();
  }

  getDistribuidor() {
    this._distribuidor.getDistribuidor().subscribe((res: DistribuidorMantenedorModel[]) => {
      this.cmbDistribuidor = res;
      this.cmbDistribuidor = this.cmbDistribuidor.map((e) => {
        e.descripcion = e.idDistribuidor + ' ' + e.nombreDistribuidor;
        return e;
      });
    }, (err: any) => {
      this.cmbDistribuidor = [];
      console.log(err);
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.callModal.bind(this),
          label: 'Ver',//this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-link'//'btn btn-danger btn btn-block'
        }
      },
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function(params: any){
          return (params.data.correct === true)?'CORRECTO':'INCORRECTO';
        }
      },
      {
        headerName: 'TIPO.DOC',
        field: this.modelGridDistribuidor.tipoDocumento,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'DOCUMENTO',
        field: this.modelGridDistribuidor.numeroIdentidad,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'R.SOCIAL',
        field: this.modelGridDistribuidor.razonSocial,
        sortable: true,
        filter: true,
        width: 220
      },
      {
        headerName: 'CLIENTE',
        field: this.modelGridDistribuidor.nombreCliente,
        sortable: true,
        filter: true,
        width: 200
      },
      // {
      //   headerName: 'COMERCIAL',
      //   field: this.modelGridDistribuidor.nombreComercial,
      //   sortable: true,
      //   filter: true,
      //   width: 320
      // },
      {
        headerName: 'COD.DISTRIBUIDOR',
        field: this.modelGridDistribuidor.codigoDistribuidor,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'COD.FABRIL',
        field: this.modelGridDistribuidor.codigoFabril,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'DET.ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        sortable: true,
        filter: true,
        width: 450
      } 
    ];
    this.rowSelection = 'multiple';
  }

  cargarGridCli() {
    this.frameworkComponentsCli = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsCli = [
      {
        headerName: 'DOCUMENTO',
        field: this.modelGridDistribuidor.numeroIdentidad,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'CLIENTE',
        field: this.modelGridDistribuidor.nombreCliente,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'COMERCIAL',
        field: this.modelGridDistribuidor.nombreComercial,
        sortable: true,
        filter: true,
        width: 320
      },
      {
        headerName: 'R.SOCIAL',
        field: this.modelGridDistribuidor.razonSocial,
        sortable: true,
        filter: true,
        width: 220
      },
      {
        headerName: 'COD.DISTRIBUIDOR',
        field: this.modelGridDistribuidor.codigoDistribuidor,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'COD.FABRIL',
        field: this.modelGridDistribuidor.codigoFabril,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'TIPO.DOC',
        field: this.modelGridDistribuidor.tipoDocumento,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.callModal.bind(this),
          label: 'Ver',
          colorBoton: 'btn btn-link'
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: 'Eliminar',
          colorBoton: 'btn btn-red'
        }
      }
    ];
    this.rowSelectionCli = 'multiple';
  }

  callModal({ rowData }) {
    this.dataDistribuidor = rowData;
    document.getElementById('abrirModal').click();
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      } else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return null;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReadyCli(params) {
    this.gridApiCli = params.api;
    this.gridColumnApiCli = params.columnApi;
  }

  onQuickFilterChangedCli() {
    this.gridApiCli.setQuickFilter(this.textoBuscarCli);
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  obtenerObjetoDistribuidor(event) {
    this.objSelected = event[0];
    if(this.objSelected != undefined) {
      this.formulario.get('idDistribuidor').setValue(this.objSelected.idDistribuidor);
      this.getAllCliente(this.objSelected.idDistribuidor);
    } else {
      this.formulario.get('idDistribuidor').setValue('');
      this.rowDataCli = [];
      this.listaVaciaCli = true;
    }
  }

  getAllCliente(idDistribuidor: string) { 
    this._distribuidor.getAllCliente(idDistribuidor).subscribe((res: DistribuidorModel[])=>{
      this.rowDataCli = res;
      this.listaVaciaCli = this.rowDataCli.length === 0 ? true : false;
    },(err:any)=>{
      this.rowDataCli = [];
      this.listaVaciaCli = true;
      this._util.mensajeErroToast(err.error.mensaje);
    });
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    // formData.append('multipart', data.multipart);
    return formData;
  }

  enviarFormulario() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._distribuidor.postUploadFileCliente(this.setFormData(this.formulario.value), this.formulario.get('idDistribuidor').value),
        loading: true,
        context: this,
      }
    ).then((res: DistribuidorModel[]) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
      this.validarRowData();
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach (e =>{
      if(!e.correct){
         this.errorData = false; 
      }
    });
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado de Clientes?',
        text: '',
        action: 'Guardar',
        funcion: this._distribuidor.postSaveFileCliente(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.mensaje, true, 3000);
    });
  }

  eliminar({ rowData }) {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea Eliminar el siguiente Cliente?',
        text: '',
        action: 'Eliminar',
        funcion: this._distribuidor.deleteCliente(rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.mensaje, true, 3000);
    });
  }

  regresar() {
    this.mostrarFormulario = false;
    this.listaVaciaCli = true;
    this.rowData = [];
    this.rowDataCli = [];
    this.formulario.reset();
  }

}
